import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableRow } from '@fgpp-ui/grid';
import { TranslateService } from '@ngx-translate/core';
import { GridFooterConfig } from '../../models/grid-footer-config.model';
import { IGroupAction } from '../../../messages-center/services/group-actions.service';
import { FormatsService } from '../../../shared/services/formats.service';

@Component({
  selector: 'app-grid-footer',
  templateUrl: './grid-footer.component.html',
  styleUrls: ['./grid-footer.component.scss']
})
export class GridFooterComponent {

  get disableActions(): boolean {
    return !this.selectedRows || !this.selectedRows.length || this.disableGroupAction;
  }

  get disableBeforAfter(): boolean {
    return !this.selectedRows || this.selectedRows.length !== 1;
  }

  @Input() set totalCount(totalCount: number) {
    this._totalCount = totalCount;
    this.totalCountFormatted = this.formatsService.toNumberFormat(totalCount);
  }

  get totalCount(): number {
    return this._totalCount;
  }

  @Input() gridFooterConfig: GridFooterConfig;
  @Input() selectedRows: Array<TableRow>;

  @Input() set groupActions(value: Array<any>) {
    this._groupActions = this.getGroupActions(value);
  }

  get groupActions(): Array<any> {
    return this._groupActions;
  }

  @Output() beforeAfterClicked = new EventEmitter<void>();
  @Output() actionClicked = new EventEmitter<IGroupAction>();
  @Output() createFromTemplateClicked = new EventEmitter<void>();

  totalCountFormatted: string;

  private _totalCount: number;
  private _groupActions: Array<any>;
  @Input() disableGroupAction: boolean = false;

  constructor(private translate: TranslateService,
              private formatsService: FormatsService) { }

  onCreateFromTemplateClick(): void {
    if (this.disableActions) {
      return;
    }
    this.createFromTemplateClicked.emit();
  }

  onAddNoteClick(): void {
    if (this.disableActions) {
      return;
    }
    const action = {
      actionId: 'ADD_NOTE',
      mandateNote: true
    };
    this.onActionClick(action);
  }

  onFollowupFlagClick(): void {
    if (this.disableActions) {
      return;
    }
    const action = {
      actionId: 'ADD_FOLLOW_UP_FLAG',
      mandateNote: false
    };
    this.onActionClick(action);
  }

  onBeforeAfterClick(): void {
    if (this.disableBeforAfter) {
      return;
    }
    this.beforeAfterClicked.emit();
  }

  onActionClick(action: IGroupAction): void {
    if (this.disableActions) {
      return;
    }
    this.actionClicked.emit(action);
  }

  private getGroupActions(value: Array<any>): Array<any> {
    return value?.map(action => {
      const tooltipKey = `button.tooltip.${action.actionId}`;
      const hasTranslation = this.translate.instant(tooltipKey) !== tooltipKey;
      return {
        ...action,
        tooltipKey: hasTranslation ? tooltipKey : null
      };
    });
  }
}
